export type ExportFormat = "csv" | "xlsx";

/** Hand a fetched file to the browser as a download. */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/**
 * Whether a fetched body is a file. Duck-typed rather than `instanceof Blob`:
 * the `Blob` a response hands back is not always the constructor in scope
 * (it is not under jsdom), and all that matters here is that it is a body with
 * a size and a type, not the text or error object a failed request leaves.
 */
export function isBlob(value: unknown): value is Blob {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as Blob).size === "number" &&
    typeof (value as Blob).type === "string" &&
    typeof (value as Blob).arrayBuffer === "function"
  );
}
